import { ItemPreferences } from '@admin/models';
import { ItemResource, Link } from '@ngx-hal/models';

export class ItemPreferencesRead {
  static readonly type = '[ItemPreferences] Read';

  constructor(readonly link: Link) {}
}

export class ItemPreferencesPatch<Entity extends ItemResource> {
  static readonly type = '[ItemPreferences] Patch';

  constructor(readonly link: Link, readonly itemPreferences: Partial<ItemPreferences<Entity>>) {}
}

export class ItemPreferencesUpdateSample<Entity extends ItemResource> {
  static readonly type = '[ItemPreferences] UpdateSample';

  constructor(readonly link: Link, readonly sample: Partial<Entity>) {}
}
